import React from 'react';

export interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
  icon: string;
  backLink?: {
    href: string;
    label: string;
  };
  actions?: React.ReactNode;
}

export function AdminPageHeader({
  title,
  subtitle,
  icon,
  backLink,
  actions,
}: AdminPageHeaderProps) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h1 className="h2">
          <i className={`bi bi-${icon} me-2`} />
          {title}
        </h1>
        {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
      </div>
      <div className="d-flex gap-2">
        {actions}
        {backLink && (
          <a href={backLink.href} className="btn btn-outline-secondary">
            <i className="bi bi-arrow-left me-1" />
            {backLink.label}
          </a>
        )}
      </div>
    </div>
  );
}

export default AdminPageHeader;
